import React from 'react'
import MaterialSymbol from '../material-symbol'

const ArrowBack = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="arrow_back" {...props} />
))

ArrowBack.displayName = 'ArrowBack'

export default ArrowBack
